module.exports = __webpack_public_path__ + "static/media/student-orange.d09c6d4a.svg";